import { render, staticRenderFns } from "./registerDatabase.vue?vue&type=template&id=62f3494d&"
import script from "./registerDatabase.vue?vue&type=script&lang=js&"
export * from "./registerDatabase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/bhc/other/registerDatabase.vue"
export default component.exports